import React from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';

// Ova komponenta se treba napraviti na globalnu jer je koristimo u obe role gde imamo sidebar
import CloseBtn from '../../../supply/components/Layout/components/Header/components/components/CloseBtn';

import API from '../../../api';
import InputNotification from './components/InputValidationMsg';
import { onUserLogout } from 'Actions/loginActions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import DeleteDialog from './components/DeactivateDialog';

class SettingsDrawer extends React.Component {
  state = {
    value: 0,
    checkedA: false,
    checkedB: false,
    checkedC: false,
    newEmail: '',
    newEmailErr: '',
    confirmNewEmail: '',
    confirmNewEmailErr: '',
    passwordChangeEmail: '',
    passwordChangeEmailErr: '',
    currentPassword: '',
    currentPasswordErr: '',
    newPassword: '',
    confirmNewPassword: '',
    confirmNewPasswordErr: '',
    email: '',
    showPassword1: false,
    showPassword2: false,
    showPassword3: false,
    showPassword4: false,
    disabledBtnEmail: false,
    validateChangingEmailFormErr: '',
    validateChangingPasswordFormErr: '',
    disabledButtonEmail: false,
    disabledPasswordEmail: false,
    disabledButtonPassword: false,
    deleteDialog: false,
    nott: null,
  };
  openDeleteDialog = () => {
    this.setState({ deleteDialog: true });
  };
  closeDeleteDialog = () => {
    this.setState({ deleteDialog: false });
  };
  componentDidMount() {
    this.getInfo();
  }

  getInfo = () => {
    API.getMyInfo()
      .then(res => {
        this.setEmail(res.data);
      })
      .catch(err => {
        console.error(err);
      });
    API.getNotificationSettings()
      .then(res => {
        this.setNotificationSettings(res.data);
      })
      .catch(err => {
        console.error(err);
      });
  };

  updateEmail = data => {
    API.postNewEmail(data)
      .then(res => {
        this.getInfo();
        this.setState(state => ({
          emailResponse: res,
          validateChangingEmailFormErr: 'Email successfully updated!',
          newEmail: '',
          confirmNewEmail: '',
          passwordChangeEmail: '',
          disabledButtonEmail: false,
        }));
      })
      .catch(err => {
        this.setState(state => ({
          validateChangingEmailFormErr: err.response.data.message,
          disabledButtonEmail: false,
        }));
      });
  };

  setEmail = email => {
    this.setState({ email: email });
  };

  setNotificationSettings = nott => {
    nott.sort(function(a, b) {
      return a.notificationTypeIndex - b.notificationTypeIndex;
    });
    this.setState({
      checkedA: nott[0].enabled,
      checkedB: nott[1].enabled,
      checkedC: nott[2].enabled,
      nott,
    });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeInput = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPassword = showPassword => event => {
    this.setState(state => ({ [showPassword]: !state[showPassword] }));
  };

  handleSwitch = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleBlurValidateEmailFormat = inputState => event => {
    if (
      event.target.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) !== null
    ) {
      this.setState({ [inputState]: '', disabledBtnEmail: false });
    } else {
      this.setState({
        [inputState]: 'Email must be in valid format: someone@test.com',
        disabledBtnEmail: true,
      });
    }
  };

  handleBlurValidateEmailConfirm = inputState => event => {
    if (this.state.newEmail === this.state.confirmNewEmail) {
      if (
        event.target.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) !==
        null
      ) {
        this.setState({ [inputState]: '', disabledBtnEmail: false });
      } else {
        this.setState({
          [inputState]: 'Email must be in valid format: someone@test.com',
          disabledBtnEmail: true,
        });
      }
    } else {
      this.setState({
        [inputState]: 'Check your entry, emails do not match',
        disabledBtnEmail: true,
      });
    }
  };

  handleBlurValidatePasswordConfirm = inputState => event => {
    if (this.state.newPassword === this.state.confirmNewPassword) {
      this.setState({
        [inputState]: '',
        disabledBtnEmail: true,
      });
    } else {
      this.setState({
        [inputState]: 'Check your entry, password do not match',
        disabledBtnEmail: true,
      });
    }
  };

  validateChangingEmailForm = event => {
    if (
      this.state.newEmail === '' ||
      this.state.confirmNewEmail === '' ||
      this.state.passwordChangeEmail === ''
    ) {
      this.setState({
        validateChangingEmailFormErr:
          'To change your email, you must enter a new email, email confirmation and password.',
      });
    } else if (
      this.state.newEmailErr === '' &&
      this.state.confirmNewEmailErr === '' &&
      this.state.passwordChangeEmailErr === ''
    ) {
      this.updateEmail({
        email: this.state.newEmail,
        password: this.state.passwordChangeEmail,
      });
      this.setState({
        validateChangingEmailFormErr: '',
        disabledButtonEmail: true,
      });
    } else {
      this.setState({
        validateChangingEmailFormErr:
          'To change your email, you must enter a new email, email confirmation and password.',
      });
    }
  };

  validateChangingPasswordForm = event => {
    if (
      this.state.currentPassword === '' ||
      this.state.newPassword === '' ||
      this.state.confirmNewPassword === ''
    ) {
      this.setState({
        validateChangingPasswordFormErr:
          'To change your password, you must enter a current password, new password and confirm new password.',
      });
    } else if (this.state.confirmNewPasswordErr === '') {
      this.updatePassword({
        newPassword: this.state.newPassword,
        oldPassword: this.state.currentPassword,
      });
      this.setState({
        validateChangingPasswordFormErr: '',
        disabledButtonPassword: true,
      });
    } else {
      this.setState({
        validateChangingPasswordFormErr:
          'To change your password, you must enter a current password, new password and confirm new password.',
      });
    }
  };

  updatePassword = data => {
    API.postNewPassword(data)
      .then(res => {
        this.getInfo();
        this.setState(state => ({
          passwordResponse: res,
          validateChangingPasswordFormErr: 'Password successfully updated!',
          currentPassword: '',
          newPassword: '',
          confirmNewPassword: '',
          disabledButtonPassword: false,
        }));
      })
      .catch(err => {
        this.setState(state => ({
          validateChangingPasswordFormErr: err.response.data.message,
          disabledButtonPassword: false,
        }));
      });
  };

  deactivateAccount = () => () => {
    API.deactivateAcc().then(this.logOut());
  };

  logOut = () => {
    this.props.onUserLogout();
  };
  changeNotification = () => {
    let form = new FormData();
    for (let prop in this.state.nott[0]) {
      if (prop === 'enabled') {
        form.append(`notificationSettings[0].${prop}`, this.state.checkedA);
      } else {
        form.append(
          `notificationSettings[0].${prop}`,
          this.state.nott[0][prop]
        );
      }
    }
    for (let prop in this.state.nott[1]) {
      if (prop === 'enabled') {
        form.append(`notificationSettings[1].${prop}`, this.state.checkedB);
      } else {
        form.append(
          `notificationSettings[1].${prop}`,
          this.state.nott[1][prop]
        );
      }
    }
    for (let prop in this.state.nott[2]) {
      if (prop === 'enabled') {
        form.append(`notificationSettings[2].${prop}`, this.state.checkedC);
      } else {
        form.append(
          `notificationSettings[2].${prop}`,
          this.state.nott[2][prop]
        );
      }
    }

    API.postNotificationSettings(form).then(response => {});
  };
  render() {
    return (
      <SwipeableDrawer
        anchor="right"
        open={this.props.settings}
        onClose={this.props.close}
        onOpen={this.props.open}
        classes={{
          paper:
            'bc-gray u-pad-r-60 u-pad-l-60 mw420 t-align-c scroll-y box-sizing-unset',
        }}
      >
        <div>
          <CloseBtn onClick={this.props.close} />
          <h2 className="t-secondary-30 u-mrg-bot-30 u-mrg-top-60">Settings</h2>

          <Tabs value={this.state.value} onChange={this.handleChange}>
            <Tab className="t-primary-13" label="ACCOUNT SETTINGS" />
            <Tab className="t-primary-13" label="NOTIFICATION SETTINGS" />
          </Tabs>

          <div className="u-mrg-top-50">
            {this.state.value === 0 && (
              <div className="settingTabs">
                <b className="c-blue-dark t-primary-18 element-block t-align-l u-mrg-bot-15">
                  Change email address
                </b>
                <p className="c-blue-dark t-primary-16 element-block t-align-l u-mrg-bot-15">
                  Current email: {this.state.email}
                </p>
                <FormControl fullWidth>
                  <InputLabel
                    htmlFor="New address"
                    classes={{
                      root: 'label--c-gray',
                    }}
                  >
                    New email address
                  </InputLabel>
                  <Input
                    classes={{
                      underline: 'underline--c-light',
                    }}
                    type="text"
                    label="New address"
                    value={this.state.newEmail}
                    onChange={this.handleChangeInput('newEmail')}
                    onBlur={this.handleBlurValidateEmailFormat('newEmailErr')}
                  />
                  <InputNotification>
                    {this.state.newEmailErr}
                  </InputNotification>
                </FormControl>
                <FormControl fullWidth className="none">
                  <InputLabel
                    htmlFor="New address"
                    classes={{
                      root: 'label--c-gray',
                    }}
                  >
                    Confirm new email address
                  </InputLabel>
                  <Input
                    classes={{
                      underline: 'underline--c-light',
                    }}
                    type="text"
                    label="New address"
                    value={this.state.confirmNewEmail}
                    onChange={this.handleChangeInput('confirmNewEmail')}
                    onBlur={this.handleBlurValidateEmailConfirm(
                      'confirmNewEmailErr'
                    )}
                  />
                  <InputNotification>
                    {this.state.confirmNewEmailErr}
                  </InputNotification>
                </FormControl>
                <FormControl fullWidth className="none">
                  <InputLabel
                    htmlFor="New address"
                    classes={{
                      root: 'label--c-gray',
                    }}
                  >
                    Password
                  </InputLabel>
                  <Input
                    classes={{
                      underline: 'underline--c-light',
                    }}
                    type={this.state.showPassword1 ? 'text' : 'password'}
                    label="New address"
                    value={this.state.passwordChangeEmail}
                    onChange={this.handleChangeInput('passwordChangeEmail')}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword(
                            'showPassword1'
                          )}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showPassword1 ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <Button
                  disabled={this.state.disabledButtonEmail}
                  fullWidth
                  variant="contained"
                  color="primary"
                  className="t-weight-b pointer u-mrg-right-0 u-mrg-top-30 "
                  onClick={this.validateChangingEmailForm}
                >
                  CHANGE EMAIL ADDRESS
                </Button>
                <InputNotification>
                  {this.state.validateChangingEmailFormErr}
                </InputNotification>

                <b className="c-blue-dark t-primary-18 element-block t-align-l u-mrg-bot-30 u-mrg-top-60">
                  Change password
                </b>
                <FormControl fullWidth>
                  <InputLabel
                    htmlFor="New address"
                    classes={{
                      root: 'label--c-gray',
                    }}
                  >
                    Current password
                  </InputLabel>
                  <Input
                    classes={{
                      underline: 'underline--c-light',
                    }}
                    type={this.state.showPassword2 ? 'text' : 'password'}
                    label="New address"
                    value={this.state.currentPassword}
                    onChange={this.handleChangeInput('currentPassword')}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword(
                            'showPassword2'
                          )}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showPassword2 ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl fullWidth className="u-mrg-top-50">
                  <InputLabel
                    htmlFor="New address"
                    classes={{
                      root: 'label--c-gray',
                    }}
                  >
                    New password
                  </InputLabel>
                  <Input
                    classes={{
                      underline: 'underline--c-light',
                    }}
                    type={this.state.showPassword3 ? 'text' : 'password'}
                    label="New address"
                    value={this.state.newPassword}
                    onChange={this.handleChangeInput('newPassword')}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword(
                            'showPassword3'
                          )}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showPassword3 ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl fullWidth className="u-mrg-top-50">
                  <InputLabel
                    htmlFor="New address"
                    classes={{
                      root: 'label--c-gray',
                    }}
                  >
                    Confirm new password
                  </InputLabel>
                  <Input
                    classes={{
                      underline: 'underline--c-light',
                    }}
                    type={this.state.showPassword4 ? 'text' : 'password'}
                    label="New address"
                    value={this.state.confirmNewPassword}
                    onChange={this.handleChangeInput('confirmNewPassword')}
                    onBlur={this.handleBlurValidatePasswordConfirm(
                      'confirmNewPasswordErr'
                    )}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword(
                            'showPassword4'
                          )}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showPassword4 ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <InputNotification>
                    {this.state.confirmNewPasswordErr}
                  </InputNotification>
                </FormControl>
                <Button
                  disabled={this.state.disabledButtonPassword}
                  fullWidth
                  variant="contained"
                  color="primary"
                  className="t-weight-b pointer u-mrg-right-0 u-mrg-top-30 "
                  onClick={this.validateChangingPasswordForm}
                >
                  CHANGE PASSWORD
                </Button>
                <InputNotification>
                  {this.state.validateChangingPasswordFormErr}
                </InputNotification>
                <b className="c-blue-dark t-primary-18 element-block t-align-l u-mrg-bot-30 u-mrg-top-60">
                  Deactivate your account
                </b>
                <div className="flexblock u-mrg-bot-30">
                  <div>
                    <b className="t-primary-16">Note:</b>
                  </div>
                  <div className="t-align-l">
                    <p className="lh-24 t-secondary-16 u-mrg-left-10">
                      If you deactivate your account, you will be logged out and
                      will lose access to Luminaire Broker. All data is retained
                      and deactivated accounts can be restored by contacting the
                      system administrator.
                    </p>
                  </div>
                </div>
                <Button
                  onClick={this.openDeleteDialog}
                  fullWidth
                  variant="contained"
                  className="t-weight-b pointer u-mrg-right-0 u-mrg-bot-60 deactivate-account"
                >
                  DEACTIVATE ACCOUNT
                </Button>
              </div>
            )}

            {this.state.value === 1 && (
              <div>
                <p className="c-blue-dark t-primary-16 t-weight-b element-block t-align-l u-mrg-bot-30 lh-28">
                  I want to receive email notifications for the following
                  events:
                </p>

                <label htmlFor="checkedA" className="notificationsSettings">
                  <span>Someone sends me a luminaire proposal</span>
                  <Switch
                    id="checkedA"
                    checked={this.state.checkedA}
                    onChange={this.handleSwitch('checkedA')}
                    value="checkedA"
                  />
                </label>
                <label htmlFor="checkedB" className="notificationsSettings">
                  <span>Someone responds to a search</span>
                  <Switch
                    id="checkedB"
                    checked={this.state.checkedB}
                    onChange={this.handleSwitch('checkedB')}
                    value="checkedB"
                  />
                </label>
                <label htmlFor="checkedC" className="notificationsSettings">
                  <span style={{ textAlign: 'left' }}>
                    When new correspondence is received from a supplier
                  </span>
                  <Switch
                    id="checkedC"
                    checked={this.state.checkedC}
                    onChange={this.handleSwitch('checkedC')}
                    value="checkedC"
                  />
                </label>
                <Button
                  // disabled={this.state.disabledButtonPassword}
                  fullWidth
                  variant="contained"
                  color="primary"
                  className="t-weight-b pointer u-mrg-right-0 u-mrg-top-30 "
                  onClick={this.changeNotification}
                >
                  CHANGE NOTIFICATION SETTINGS
                </Button>
              </div>
            )}
          </div>
        </div>
        <DeleteDialog
          element={'account'}
          doDelete={this.deactivateAccount()}
          handleClose={this.closeDeleteDialog}
          isOpen={this.state.deleteDialog}
        />
      </SwipeableDrawer>
    );
  }
}

export default withRouter(
  connect(null, {
    onUserLogout,
  })(SettingsDrawer)
);
